(function(){
  function initMediDovKitContact(){
    var form=document.getElementById('mdkForm');
    if(!form || form.dataset.medidovContactReady==='true') return;
    form.dataset.medidovContactReady='true';
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      e.stopImmediatePropagation();

      var errorBanner=document.getElementById('mdkErrorBanner');
      var skillsError=document.getElementById('mdkSkillsError');
      var buildStyleError=document.getElementById('mdkBuildStyleError');
      var skillOtherBox=document.getElementById('mdkSkillOtherBox');
      var skillOtherText=document.getElementById('mdkSkillOtherText');
      var success=document.getElementById('mdkSuccessView');

      if(!form.checkValidity()){
        form.reportValidity();
        if(errorBanner) errorBanner.classList.add('mdk-show');
        return;
      }

      var checkedSkills=Array.prototype.slice.call(form.querySelectorAll('input[name="skills"]:checked'));
      var otherChecked=skillOtherBox && skillOtherBox.checked;
      var otherText=skillOtherText ? skillOtherText.value.trim() : '';
      var hasSkills=checkedSkills.length>0 && (!otherChecked || otherText!=='');
      if(!hasSkills){
        if(skillsError){skillsError.style.display='block';}
        if(errorBanner){errorBanner.classList.add('mdk-show');errorBanner.scrollIntoView({behavior:'smooth',block:'center'});}
        return;
      }
      if(skillsError) skillsError.style.display='none';

      var buildStyle=form.querySelector('input[name="buildStyle"]:checked');
      if(!buildStyle){
        if(buildStyleError) buildStyleError.style.display='block';
        if(errorBanner){errorBanner.classList.add('mdk-show');errorBanner.scrollIntoView({behavior:'smooth',block:'center'});}
        return;
      }
      if(buildStyleError) buildStyleError.style.display='none';

      var data=new FormData(form);
      var school=(data.get('school')||'').toString().trim();
      var title=(data.get('title')||'').toString().trim();
      var skills=checkedSkills.map(function(cb){return cb.value;});
      if(otherChecked && otherText) skills.push('Other: '+otherText);

      var lines=[
        'New custom kit request',
        '',
        'Institution: '+school,
        'Program/department: '+(data.get('department')||''),
        'Contact: '+(data.get('contactName')||'')+(title?' ('+title+')':''),
        'Email: '+(data.get('email')||''),
        'Phone: '+(data.get('phone')||'n/a'),
        '',
        'Students per cohort: '+(data.get('students')||''),
        'Needed by: '+(data.get('needBy')||'n/a'),
        'Skills/areas: '+(skills.join(', ')||'n/a'),
        'Build style: '+(data.get('buildStyle')||''),
        '',
        'Number of distinct kits: '+(data.get('numKits')||'n/a'),
        '',
        'Notes: '+(data.get('notes')||'n/a')
      ];

      var payload=new URLSearchParams();
      payload.append('form_type','contact');
      payload.append('utf8','✓');
      payload.append('contact[email]',(data.get('email')||'').toString());
      payload.append('contact[body]',lines.join('\n'));
      payload.append('contact[subject]','Custom kit request — '+school);
      payload.append('contact[tags]','custom-kit');

      var button=form.querySelector('.mdk-submit');
      if(button){button.disabled=true;button.textContent='Sending...';}

      try{
        var response=await fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'text/html,application/xhtml+xml'},body:payload.toString(),redirect:'follow'});
        if(!response.ok) throw new Error('Contact form submission failed');
        form.style.display='none';
        if(success) success.classList.add('mdk-show');
      }catch(err){
        if(button){button.disabled=false;button.textContent='Send request';}
        if(errorBanner){errorBanner.textContent='We couldn’t send the request. Please try again or email info@medidov.ca directly.';errorBanner.classList.add('mdk-show');errorBanner.scrollIntoView({behavior:'smooth',block:'center'});}
      }
    }, true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initMediDovKitContact);
  else initMediDovKitContact();
})();
